export default __webpack_public_path__ + "images/4f1d76b0c546516997a1090feaa2d572-hobbies.png";